import React from "react";
import { TriggerNode } from "../../../views/convoauto-pages/bot-studio/types";
import { TemplateModule } from "../../../views/marketing-pages/templates";
import { EmptyTriggerDropZone } from "../../shared/trigger-shared/node-menu";
import { OnMessageTriggerCard } from "./triggers/on-message";
import { OnEventTriggerCard } from "./triggers/on-event";
import { RunAtSpecificTimeTriggerCard } from "./triggers/run-at-specific-time";
import { LeadFromCTWATriggerCard } from "./triggers/lead-ctwa";
import { NewLeadTriggerCard } from "./triggers/new-lead";
import { RcsTriggerCard } from "./triggers/rcs";


interface TriggerNodeCardProps {
  node: TriggerNode | null;
  onChange: (n: TriggerNode) => void;
  onDelete?: () => void;
  onReset?: () => void;
  templates?: TemplateModule[];
  journeyId?: string;
}

export const TriggerNodeCard: React.FC<TriggerNodeCardProps> = ({
  node,
  onChange,
  onDelete = () => { },
  onReset = () => { },
  templates = [],
  journeyId,
}) => {
  if (!node) return <EmptyTriggerDropZone />;

  switch (node.type) {
    case "On Message":
      return (
        <OnMessageTriggerCard
          node={node}
          onChange={onChange}
          onDelete={onDelete}
          onReset={onReset}
        />
      );
    
    case "New Lead":
      return (
        <NewLeadTriggerCard
          node={node}
          onChange={onChange}
          onDelete={onDelete}
          onReset={onReset}
          journeyId={journeyId}
        />
      );
    
    case "On Event":
      return (
        <OnEventTriggerCard
          node={node}
          onChange={onChange}
          onDelete={onDelete}
          onReset={onReset}
        />
      );
    
    case "Run at Specific Time":
      return (
        <RunAtSpecificTimeTriggerCard
          node={node}
          onChange={onChange}
          onDelete={onDelete}
          onReset={onReset}
        />
      );
    
    // case "Send Message Template":
    //   return (
    //     <SendMessageTemplateActionCard
    //       node={node as any}
    //       templates={templates}
    //       onChange={onChange as any}
    //       onDelete={onDelete}
    //       onReset={onReset}
    //     />
    //   );
    
    case "Lead from CTWA":
      return (
        <LeadFromCTWATriggerCard
          node={node}
          onChange={onChange}
          onDelete={onDelete}
          onReset={onReset}
        />
      );

    case "RCS Trigger Node":
      return (
        <RcsTriggerCard
          node={node}
          onChange={onChange}
          onDelete={onDelete}
          onReset={onReset}
        />
      );

    default:
      return <EmptyTriggerDropZone />;
  }
};